import toString from './to-string';
var lowerCase = function (str) {
    return toString(str).toLowerCase();
};
export default lowerCase;
//# sourceMappingURL=lower-case.js.map